// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endpoint-content {
  padding-right: 32px;
  padding-left: 100px;
  background: #ffffff;
  display: flex;
  gap: 24px;
  height: 100%;
  /* border-radius: 8px; */
}

/* Left Column - Main content (508px width from Figma) */
.endpoint-left-column {
  /* flex: 0 0 508px;
  max-width: 508px; */
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0;
}

/* Right Column - Code section (330px width from Figma) */
.endpoint-right-column {
  /* flex: 0 0 330px; */
  max-width: 330px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: sticky;
  top: 24px;
  align-self: flex-start;
  max-height: calc(100vh - 48px);
  padding: 0;
}

.endpoint-header-wrapper {
  /* margin-bottom: 24px; */
  gap: 24px;
}

.endpoint-try-button {
  margin-top: 4px;
  flex-shrink: 0;
}

.request-section {
  /* margin-top: 32px; */
}

.section-heading {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.88);
  margin-bottom: 16px;
  margin-top: 0;
}

/* Responsive Layout */
@media (max-width: 1200px) {
  .endpoint-content {
    flex-direction: column;
  }

  .endpoint-left-column {
    flex: 1;
    max-width: 100%;
  }

  .endpoint-right-column {
    position: static;
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/EndPointSection/EndpointSection.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE;qBACmB;EACnB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".endpoint-content {\n  padding-right: 32px;\n  padding-left: 100px;\n  background: #ffffff;\n  display: flex;\n  gap: 24px;\n  height: 100%;\n  /* border-radius: 8px; */\n}\n\n/* Left Column - Main content (508px width from Figma) */\n.endpoint-left-column {\n  /* flex: 0 0 508px;\n  max-width: 508px; */\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding: 0;\n}\n\n/* Right Column - Code section (330px width from Figma) */\n.endpoint-right-column {\n  /* flex: 0 0 330px; */\n  max-width: 330px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: sticky;\n  top: 24px;\n  align-self: flex-start;\n  max-height: calc(100vh - 48px);\n  padding: 0;\n}\n\n.endpoint-header-wrapper {\n  /* margin-bottom: 24px; */\n  gap: 24px;\n}\n\n.endpoint-try-button {\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.request-section {\n  /* margin-top: 32px; */\n}\n\n.section-heading {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  color: rgba(0, 0, 0, 0.88);\n  margin-bottom: 16px;\n  margin-top: 0;\n}\n\n/* Responsive Layout */\n@media (max-width: 1200px) {\n  .endpoint-content {\n    flex-direction: column;\n  }\n\n  .endpoint-left-column {\n    flex: 1;\n    max-width: 100%;\n  }\n\n  .endpoint-right-column {\n    position: static;\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
